import { render, staticRenderFns } from "./AffairHostelInfo.vue?vue&type=template&id=df972670"
import script from "./AffairHostelInfo.vue?vue&type=script&lang=js"
export * from "./AffairHostelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports